<template>
  <div>
    <v-form ref="formPersonal" lazy-validation>
      <ComunDialogComp fullscreen v-model="estadoComp" :title="formTitle" @close-modal="$emit('close')">
        <template v-slot:body>
          <div>
            <v-tabs dark class="rounded-lg" dense background-color="primary" active-class="tab-active"
              slider-color="#ffbc00" v-model="tab_inicio" color="#ffbc00">
              <v-tab href="#tab-0" class="font-weight-black" @click="eventTab(0)">
                Datos Personales
              </v-tab>

              <v-tab href="#tab-2" class="font-weight-black" @click="eventTab(2)" :disabled="disabled_tabs">
                Formación académica
              </v-tab>
              <v-tab href="#tab-3" class="font-weight-black" @click="eventTab(3)" :disabled="disabled_tabs">
                Idiomas
              </v-tab>
              <v-tab href="#tab-4" class="font-weight-black" @click="eventTab(4)" :disabled="disabled_tabs">
                Capacitación
              </v-tab>
              <v-tab href="#tab-5" class="font-weight-black" @click="eventTab(5)" :disabled="disabled_tabs">
                Experiencia Laboral
              </v-tab>
              <v-tab href="#tab-6" class="font-weight-black" @click="eventTab(6)" :disabled="disabled_tabs">
                Seguro
              </v-tab>



              <v-tab-item value="tab-0" class="py-2">
                <component :is="compNameTab0" :estadoComp="estadoComponenteTab0" :parametros="parametroComp" :parametros2="parametros2"
                  :parametrosUsers="parametroUsersComp" @reloadComp="reloadComp" @close="$emit('close')">
                </component>
              </v-tab-item>

              <v-tab-item value="tab-2" class="py-2">
                <component :is="compNameTab2" :estadoComp="estadoComponenteTab2" :parametros="parametroComp"
                  @reloadComp="reloadComp" @close="$emit('close')">
                </component>
              </v-tab-item>

              <v-tab-item value="tab-3" class="py-2">
                <component :is="compNameTab3" :estadoComp="estadoComponenteTab3" :parametros="parametroComp"
                  @reloadComp="reloadComp" @close="$emit('close')">
                </component>
              </v-tab-item>

              <v-tab-item tab value="tab-4" class="py-2">
                <component :is="compNameTab4" :estadoComp="estadoComponenteTab4" :parametros="parametroComp"
                  @reloadComp="reloadComp" @close="$emit('close')">
                </component>
              </v-tab-item>

              <v-tab-item tab value="tab-5" class="py-2">
                <component :is="compNameTab5" :estadoComp="estadoComponenteTab5" :parametros="parametroComp"
                  @reloadComp="reloadComp" @close="$emit('close')">
                </component>
              </v-tab-item>
              <v-tab-item tab value="tab-6" class="py-2">
                <component :is="compNameTab6" :estadoComp="estadoComponenteTab6" :parametros="parametroComp"
                  @reloadComp="reloadComp" @close="$emit('close')">
                </component>
              </v-tab-item>

              <v-tab-item tab value="any" class="py-2">
                <h1>ANY TABS: {{ tab_id }}</h1>
              </v-tab-item>
            </v-tabs>
          </div>
        </template>
      </ComunDialogComp>

      <span v-if="test">
        <code> Datos :{{ Datos }} </code>
        <code> Parametros :{{ parametros }} </code>
        <code>user:{{ parametroUsersComp }}</code>
      </span>
    </v-form>

    <!-- fin modal del Usuario -->
  </div>
</template>

<script>
// import axios,  { API_URL } from '@/helpers/axios'
import { mapMutations } from "vuex";
import ComunDialogComp from "../../../components/ComponentsEst/ComunDialogComp.vue";
import datosPersonal from "./components/datosPersonalComp.vue";
import datosUsuario from "./components/datosUsuarioComp.vue"
import formacionAcademica from "./components/formacionAcademicaComp.vue";
import idioma from "./components/idiomaComp.vue";
import capacitacion from "./components/capacitacionComp.vue";
import experienciaLaboral from "./components/experienciaLaboralComp.vue";
import seguro from "./components/seguroComp.vue";

export default {
  name: "compRegistroPersonalTabs",

  components: {
    datosPersonal,
    datosUsuario,
    formacionAcademica,
    idioma,
    capacitacion,
    experienciaLaboral,
    seguro,
    ComunDialogComp,
  },

  props: {
    parametros: {
      type: Object,
    },
    parametros2: {
      type: Array,
    },
    estadoComp: {
      type: Boolean,
    },
    usersParams: {
      type: Object,
    },
  },

 
  data: () => ({
    session: sessionStorage, // variables de sesion del usuario
    // rutaServer: API_URL,

    test: false,
    disabled_tabs: true,
    tab_inicio: "tab-0",
    tab_id: 1,
    items: ["Web", "Shopping", "Videos", "Images"],
    more: ["News", "Maps", "Books", "Flights", "Apps"],
    compName: "",
    estadoComponente: false,
    parametroComp: {},
    parametroUsersComp: {},

    compNameTab0: "",
    estadoComponenteTab0: false,

    compNameTab1: "",
    estadoComponenteTab1: false,

    compNameTab2: "",
    estadoComponenteTab2: false,

    compNameTab3: "",
    estadoComponenteTab3: false,

    compNameTab4: "",
    estadoComponenteTab4: false,

    compNameTab5: "",
    estadoComponenteTab5: false,

    compNameTab6: "",
    estadoComponenteTab6: false,
  }),

  created(){
    this.$on('usuarioCreado', ()=>{
      this.$emit('usuarioCreado');
    })
  },
  mounted() {
    this.loadMain();
  },

  //computadas
  computed: {
    formTitle() {
      return this.parametros.evento === "agregar"
        ? " Crear personal"
        : "Editar personal";
    },
  },

  watch: {
    // cada vez que cambie, esta función será ejecutada
    estadoComp: function () {
      if (this.estadoComp) {
        
        this.loadMain();
      } else {
    
        this.limpiarForm();
      }
    },
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    ////////////////////////////////////////////////////////

    //  ------- Cargar todos los registros principales al iniciar el componente   --------
    async loadMain() {
      if (this.parametros.evento == "agregar") {
        this.disabled_tabs = true;
      }

      if (this.parametros.evento == "editar") {
        this.disabled_tabs = false;
      }

      this.eventTab(0);
    },

    addItem(item) {
      const removed = this.items.splice(0, 1);
      this.items.push(...this.more.splice(this.more.indexOf(item), 1));
      this.more.push(...removed);
      this.$nextTick(() => {
        this.currentItem = "tab-" + item;
      });
    },

    eventTab(id) {
      this.tab_id = id;

      this.parametroComp = this.parametros;
      this.parametroUsersComp = this.usersParams


      if (id == 0) {
        this.compNameTab0 = "datosPersonal";
        this.estadoComponenteTab0 = true;
      }
      if (id == 1) {
        this.compNameTab1 = "datosUsuario";
        this.estadoComponenteTab1 = true;
      }

      if (id == 2) {
        this.compNameTab2 = "formacionAcademica";
        this.estadoComponenteTab2 = true;
      }

      if (id == 3) {
        this.compNameTab3 = "idioma";
        this.estadoComponenteTab3 = true;
      }

      if (id == 4) {
        this.compNameTab4 = "capacitacion";
        this.estadoComponenteTab4 = true;
      }

      if (id == 5) {
        this.compNameTab5 = "experienciaLaboral";
        this.estadoComponenteTab5 = true;
      }

      if (id == 6) {
        this.compNameTab6 = "seguro";
        this.estadoComponenteTab6 = true;
      }
    },

    limpiarForm() {
      this.tab_inicio = "tab-0";

      this.estadoComponente = false;
      this.parametroComp = {};
      this.estadoComponenteTab0 = false;
      this.estadoComponenteTab1 = false;
      this.estadoComponenteTab2 = false;
      this.estadoComponenteTab3 = false;
      this.estadoComponenteTab4 = false;
      this.estadoComponenteTab5 = false;
      this.estadoComponenteTab6 = false;
    },

    reloadComp() { //procedencia
    
      this.$emit("reloadComp", "datosPersonal");
    },
  },
};
</script>

<style scoped>
.fondo_add_img {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
  cursor: pointer;
  cursor: hand;
  border: 4px solid #fff;
  border-color: #474545;
  color: #524f4f;
}
</style>
